module.exports = __webpack_public_path__ + "static/img/apple-answer.bce627c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/apple-answer.svg
// module id = P9I+
// module chunks = 0